import { useDeleteAPI, usePatchAPI, usePostAPI } from '@api';
import {
	APICallProps, TBulkDeleteCPIIncreaseRequest, TBulkScheduleCPIIncreaseRequest, TCPIIncrease, TScheduleCPIIncreaseRequest, TUpdateCPIIncreaseRequest
} from '@types';
import { useRecoilValue } from 'recoil';
import { XCustomerID } from '@state';


export const useScheduleCPIIncrease = () => {
	const customerID = useRecoilValue(XCustomerID);
	const headers = customerID ? { 'X-Customer-Id': `${customerID}` } : undefined;
	const {
		callAPI,
		data,
		error,
		isLoading,
	} = usePostAPI({
		endpoint: '/api/cpi-increase',
		domain: 'ShipmentAPI',
		headers,
	});

	return {
		callScheduleCPIIncrease: callAPI as (props?: APICallProps<TScheduleCPIIncreaseRequest>) => Promise<{ data: { data: TCPIIncrease } | null; error: null }>,
		data: data?.data as TCPIIncrease | undefined,
		error,
		isLoading,
	};
};

export const useUpdateCPIIncrease = () => {
	const customerID = useRecoilValue(XCustomerID);
	const headers = customerID ? { 'X-Customer-Id': `${customerID}` } : undefined;
	const {
		callAPI,
		data,
		error,
		isLoading,
	} = usePatchAPI({
		endpoint: '/api/cpi-increase/{1}',
		domain: 'ShipmentAPI',
		headers,
	});

	return {
		callUpdateCPIIncrease: callAPI as (props?: APICallProps<TUpdateCPIIncreaseRequest>) => Promise<{ data: { data: TCPIIncrease } | null; error: null }>,
		data: data?.data as TCPIIncrease | undefined,
		error,
		isLoading,
	};
};

export const useBulkScheduleCPIIncrease = () => {
	const customerID = useRecoilValue(XCustomerID);
	const headers = customerID ? { 'X-Customer-Id': `${customerID}` } : undefined;
	const {
		callAPI,
		error,
		isLoading,
	} = usePostAPI({
		endpoint: '/api/cpi-increase/bulk',
		domain: 'ShipmentAPI',
		headers,
	});

	return {
		callBulkScheduleCPIIncrease: callAPI as (props?: APICallProps<TBulkScheduleCPIIncreaseRequest>) => Promise<{ data: { message: string } | null; error: null }>,
		error,
		isLoading,
	};
};

export const useDeleteBulkCPIIncrease = () => {
	const customerID = useRecoilValue(XCustomerID);
	const headers = customerID ? { 'X-Customer-Id': `${customerID}` } : undefined;
	const {
		callAPI,
		error,
		isLoading,
	} = useDeleteAPI({
		endpoint: '/api/cpi-increase/bulk',
		domain: 'ShipmentAPI',
		headers,
	});

	return {
		callDeleteBulkCPIIncrease: callAPI as (props?: APICallProps<TBulkDeleteCPIIncreaseRequest>) => Promise<{ data: { message: string } | null; error: null }>,
		error,
		isLoading,
	};
};

export const useDeleteCPIIncrease = () => {
	const customerID = useRecoilValue(XCustomerID);
	const headers = customerID ? { 'X-Customer-Id': `${customerID}` } : undefined;
	const {
		callAPI,
		error,
		isLoading,
	} = useDeleteAPI({
		endpoint: '/api/cpi-increase/{1}',
		domain: 'ShipmentAPI',
		headers,
	});
	return {
		callDeleteCPIIncrease: (id: string ) => callAPI({ routes: [id] }),
		error,
		isLoading,
	};
}
